export default "__VITE_ASSET__fbcc92e4__"